import * as React from 'react';
import ConfirmationModal from 'components/Common/confirmationModal';
import './previewCycleConfirmationModal.scss';

export interface IPreviewCycleConfirmationModalProps {
    isModalOpen: boolean;
    closeModal: () => void;
    onPreviewCycleClick: () => void;
}

export class PreviewCycleConfirmationModal extends
    React.Component<IPreviewCycleConfirmationModalProps> {
    constructor(props: IPreviewCycleConfirmationModalProps) {
        super(props);
        this._closePreviewCycleModal = this._closePreviewCycleModal.bind(this);
        this._previewCycleClick = this._previewCycleClick.bind(this);
    }

    render(): React.ReactNode {
        if (!this.props.isModalOpen) {
            return null;
        }

        return (
            <ConfirmationModal
                cancelMessage="Cancel"
                className="preview-cycle-modal"
                confirmMessage="Yes, Preview Cycle"
                message={this.renderPreviewCycleModalBody()}
                onCancel={this._closePreviewCycleModal}
                onClose={this._closePreviewCycleModal}
                onConfirm={this._previewCycleClick}
                title="Ready to preview your cycle?"
            />
        );
    }

    renderPreviewCycleModalBody(): React.ReactNode {
        return (
            <div className="preview-cycle-modal__body">
                <p>Cycle preview will:</p>
                <ul>
                    <li>
                        <i className="icon-check" />
                        Move cycle from pending to current
                    </li>
                    <li>
                        <i className="icon-check" />
                        Unlock team view for preview
                    </li>
                    <li>
                        <i className="icon-check" />
                        Enable further team adjustments to be made before opening cycle
                    </li>
                    <li>
                        <i className="icon-check" />
                        Does not notify managers
                    </li>
                </ul>
            </div>
        );
    }

    private _closePreviewCycleModal(): void {
        this.props.closeModal();
    }

    private _previewCycleClick(): void {
        this._closePreviewCycleModal();
        this.props.onPreviewCycleClick();
    }
}

export default PreviewCycleConfirmationModal;